<template>
  <div class="py-9 px-28 w-full m-auto">
    <div class="flex items-center justify-between">
      <h2 class="text-dkgray text-2xl font-bold">Support-All Contacts</h2>

      <router-link
        v-can="'create-user'"
        :to="{ name: 'Admin Create User' }"
        class="bg-idBlued px-3 py-2 rounded flex justify-between items-center text-white text-xs font-mullish"
      >
        <img src="@/assets/images/icons/customer-support.svg" alt="" />
        <span class="ml-2">Create new user</span>
      </router-link>
    </div>

    <div class="mt-6">
      <api-table
        apiUrl="/contacts"
        :fields="fields"
        :show-page="true"
        :show-search="true"
        placeholder="Search by name, phone number or email"
      >
        <template slot="name" slot-scope="props">
          <div class="">
            <p class="font-bold text-dkgray">
              {{ props.rowData.contactName }}
            </p>
            <p class="text-xs text-mdgray">{{ props.rowData.contactEmail }}</p>
          </div>
          <div></div>
        </template>

        <template slot="action" slot-scope="props">
          <router-link
            v-can="'get-one-contact'"
            :to="{ name: 'Support Reply', params: { id: props.rowData._id } }"
            class="bg-oneGreen text-center text-white text-xs rounded py-1 px-2 mr-2"
          >
            View
          </router-link>
        </template>
      </api-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "SupportView",

  data() {
    const tc = "bg-green-100 py-3.5 text-cadet font-semibold text-sm";
    const dc = "py-2 text-xs text-romanSilver";
    return {
      fields: [
        {
          name: "id",
          title: "S/N",
          titleClass: `${tc} text-left pl-4 `,
          dataClass: `${dc} text-left pl-4`,
        },

        {
          name: "name",
          title: "Name",
          titleClass: `${tc} text-left pl-4 `,
          dataClass: `${dc} text-left pl-4`,
        },
        {
          name: "contactPhone",
          title: "Phone Number",
          titleClass: `${tc} text-left pl-4 `,
          dataClass: `${dc} text-left pl-4`,
        },
        {
          name: "subject",
          title: "Subject",
          titleClass: `${tc} text-left pl-4 `,
          dataClass: `${dc} text-left pl-4 text-blue-500 font-bold`,
        },
        {
          name: "action",
          title: "Actions",
          titleClass: `${tc} text-left pl-4 `,
          dataClass: `${dc} text-left pl-4`,
        },
      ],
    };
  },

  methods: {
    async setUser(acn, id) {
      try {
        const rep = await this.$swal({
          icon: "question",
          text: `Are you sure you want to ${acn} this user?`,
          showDenyButton: true,
          confirmButtonText: "YES",
          denyButtonText: "No",
        });

        if (!rep.isConfirmed) {
          return;
        }

        const res = await this.$http.get(`users/${id}/toggle-status`);

        if (!res) {
          return;
        }

        this.$events.fire("table-refresh");

        this.$swal({
          icon: "success",
          text: `${acn} Successfully`,
        });
      } catch (error) {
        console.log({ error });
      }
    },
  },
};
</script>
